
import type {
    GetEventApplicationFormWihoutAuthRequestType,
    GetEventApplicationFormWihoutAuthResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetEventApplicationFormWihoutAuth = async (params:GetEventApplicationFormWihoutAuthRequestType): Promise<GetEventApplicationFormWihoutAuthResponseType> => {
    return await axios(`${SERVER_ADDRESS}/event/getApplicationFormWithoutAuth`, {
        method: "GET",
        headers: getHeaders(),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetEventApplicationFormWihoutAuth;
